import { configureStore } from "@reduxjs/toolkit";
import adminLoginReducer from "./features/authentication/adminLoginSlice";



export const store = configureStore({
  reducer: {
    signin: adminLoginReducer,
  },
});
